import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
// import AddIcon from '@material-ui/icons/Add';
import HomeIcon from '../icons/HomeIcon';
import SolutionsMenuIcon from './SolutionsMenuIcon';
import ProductIcon from './ProductIcon';
import AppIcon from '../icons/AppIcon';
import CloudserviceIcon from './CloudserviceIcon';
import BackToOld from './BackToOld';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import IconButton from '@material-ui/core/IconButton';
import MailIcon from '@material-ui/icons/Mail';
import Badge from '@material-ui/core/Badge';
import BasketIcon from '../icons/BasketIcon';
import AutorizationIcon from '../icons/AutorizationIcon';
import FavoritesIcon from '../icons/FavoritesIcon';
import ArchiveIcon from '../icons/ArchiveIcon';
import PartnersIcon from '../icons/PartnersIcon'

const theme = createMuiTheme({
	palette: {
		primary: {
			main: '#BCBBD0',
		},

		secondary: {
			main: '#4e3e57',
		},
	},
});

const useStyles = makeStyles((theme) => ({
	margin: {
		margin: theme.spacing(1),
	},

	extendedIcon: {
		marginRight: theme.spacing(1),
	},

	normal: {
		backgroundColor: '#BCBBD0',
		'&:hover': {
			backgroundColor: '#BCBBD0',
		},
		color: '#FFFFFF',
		marginRight: theme.spacing(1),
		marginLeft: theme.spacing(1),
		height: 48,
		width: 48
	},
	normal1: {
		backgroundColor: '#BCBBD0',
		'&:hover': {
			backgroundColor: '#BCBBD0',
		},
		color: '#FFFFFF',
		marginRight: theme.spacing(1),
		marginLeft: theme.spacing(1),
		height: 48,
		width: 48,
		[theme.breakpoints.down(440)]: {
			marginLeft:0
		},
	},
	normal2: {
		backgroundColor: '#BCBBD0',
		'&:hover': {
			backgroundColor: '#BCBBD0',
		},
		color: '#FFFFFF',
		marginRight: theme.spacing(1),
		marginLeft: theme.spacing(1),
		height: 48,
		width: 48,
		[theme.breakpoints.down(440)]: {
			marginLeft:0,
			marginRight:0
		},
	},

	big: {
		height: 62,
		width: 62,
		borderRadius: 24,
		boxShadow: 'none',
		color: '#FFFFFF',
		lineHeight: 1,
		backgroundColor: '#505067',
		'&:hover': {
			backgroundColor: '#505067',
		},
	},

	middle: {
		height: 48,
		width: 48,
		borderRadius: 20,
		boxShadow: 'none',
		color: '#FFFFFF',
		lineHeight: 1,
		backgroundColor: '#505067',
		'&:hover': {
			backgroundColor: '#505067',
		},
	},
}));

const StyledBadge = withStyles((theme) => ({
	badge: {
		top: 32,
		right: -6,
		height: 10,
		width: 10,
		borderRadius: 5,
		backgroundColor: '#EB505E'
	},
}))(Badge);

export default function FloatingActionButtonSize(props) {
	const classes = useStyles();
	const getBackground = () => {
		return props.isActive === true ? '#EB505E' : '#FFFFFF'
	}
	const isActive = props.isActive

	return (
		<ThemeProvider theme={theme}>
			{
				props.icon === 0
					?
					<IconButton
						href={props.href ? props.href : ''}
						color="primary"
						aria-label="Home"
						className={props.size ? classes[props.size] : classes.normal}
						style={{ backgroundColor: window.location.pathname === '/' ? '#4e3e58' : '' }}
					>
						<HomeIcon fill={window.location.pathname === '/' ? '#EB505E' : '#FFFFFF'} />
					</IconButton>
					:
					null
			}

			{
				props.icon === 1
					?
					<IconButton
						href={props.href ? props.href : ''}
						color="primary"
						aria-label="Solutions"
						className={props.size ? classes[props.size] : classes.normal}
						style={{ backgroundColor: isActive ? '#4e3e58' : '' }}
					>
						<SolutionsMenuIcon fill={getBackground()} />
					</IconButton>
					:
					null
			}

			{
				props.icon === 2
					?
					<IconButton
						href={props.href ? props.href : ''}
						color="primary"
						aria-label="Products"
						className={props.size ? classes[props.size] : classes.normal}
						style={{ backgroundColor: isActive ? '#4e3e58' : '' }}
					>
						<ProductIcon fill={getBackground()} />
					</IconButton>
					:
					null
			}

			{
				props.icon === 3
					?
					<IconButton
						href={props.href ? props.href : ''}
						color="primary"
						aria-label="Applications"
						className={props.size ? classes[props.size] : classes.normal}
						style={{ backgroundColor: props.isActive ? '#4e3e58' : '' }}
					>
						<AppIcon fill={getBackground()} />
					</IconButton>
					:
					null
			}

			{
				props.icon === 4
					?
					<IconButton
						href={props.href ? props.href : ''}
						color="primary"
						aria-label="Cloud"
						className={props.size ? classes[props.size] : classes.normal}
						style={{ backgroundColor: props.isActive ? '#4e3e58' : '' }}
					>
						<CloudserviceIcon fill={getBackground()} />
					</IconButton>
					:
					null
			}

			{
				props.icon === 5
					?
					<IconButton
						href={props.href ? props.href : ''}
						color="primary"
						aria-label="Cloud"
						className={props.size ? classes[props.size] : classes.normal}
						style={{ backgroundColor: props.isActive ? '#4e3e58' : '' }}
					>
						<BackToOld fill={getBackground()} />
					</IconButton>
					:
					null
			}
			{
				props.icon === 10
					?
					<IconButton
						href={props.href ? props.href : ''}
						color="primary"
						aria-label="archive"
						className={props.size ? classes[props.size] : classes.normal}
						style={{ backgroundColor: isActive ? '#4e3e58' : '' }}
					>
						<ArchiveIcon fill={getBackground()} />
					</IconButton>
					:
					null
			}
			{
				props.icon === 11
					?
					<IconButton
						href={props.href ? props.href : ''}
						color="primary"
						aria-label="archive"
						className={props.size ? classes[props.size] : classes.normal}
						style={{ backgroundColor: isActive ? '#4e3e58' : '' }}
					>
						<PartnersIcon fill={getBackground()} />
					</IconButton>
					:
					null
			}

			{
				props.icon === 12
					?
					<IconButton
						href={props.href ? props.href : ''}
						color="primary"
						aria-label="archive"
						className={props.size ? classes[props.size] : classes.normal}
						style={{ backgroundColor: isActive ? '#4e3e58' : '' }}
					>
						{props.badge 
							?
							<StyledBadge
								color="secondary"
								variant="dot"
							>
								<FavoritesIcon fill={'#FFFFFF'} />
							</StyledBadge>
							:
							<FavoritesIcon fill={'#FFFFFF'} />
						}
					</IconButton>
					:
					null
			}


			{
				props.icon !== 0 && props.icon !== 1 && props.icon !== 2 && props.icon !== 3 && props.icon !== 4 && props.icon !== 10 && props.icon !== 11 && props.icon !== 12 ?
					<IconButton href={props.href ? props.href : ''} color="primary" aria-label="" className={props.size ? classes[props.size] : classes.normal} style={{ backgroundColor: props.active ? '#4e3e58' : '' }}>
						{/* <IconButton color="primary" aria-label="" className={props.size ? classes[props.size] : classes.normal} style={{ backgroundColor: '#4e3e58' }}> */}
						{props.badge ?
							<StyledBadge
								color="secondary"
								variant="dot"
							>
								{
									props.icon === 5 ? <FavoritesIcon fill={'#FFFFFF'} /> :
										props.icon === 6 ? <BasketIcon fill={'#FFFFFF'} /> :
											props.icon === 7 ? <AutorizationIcon /> :
												<MailIcon />
								}
							</StyledBadge> :
							/** switch  https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Statements/switch */
							// props.icon === 0 ? <HomeIcon fill={props.active ? '#EB505E' : '#FFFFFF'} /> :
							// props.icon === 1 ? <ReadymadeIcon fill={window.location.hash.substr(2, 9) === 'solutions' ? '#EB505E' : '#FFFFFF'} /> :
							// props.icon === 2 ? <ProductIcon fill={window.location.hash.substr(2, 8) === 'products' ? '#EB505E' : '#FFFFFF'} /> :
							// props.icon === 3 ? <AppIcon fill={window.location.hash.substr(2, 12) === 'applications' ? '#EB505E' : '#FFFFFF'} /> :
							// props.icon === 4 ? <CloudserviceIcon fill={window.location.hash.substr(2, 5) === 'cloud' ? '#EB505E' : '#FFFFFF'} /> :
							props.icon === 5 ? <FavoritesIcon /> :
								props.icon === 6 ? <BasketIcon fill={'#FFFFFF'} /> :
									props.icon === 7 ? <AutorizationIcon /> :
										props.icon === 8 ? props.iconTxt : ''
							// <MailIcon />
						}
					</IconButton>
					:
					''
			}
		</ThemeProvider >
	);
}
